import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { GridLayoutSizes } from 'types/app';
import { useContent, useDimensions } from 'hooks';
import { getImageSrc } from 'helpers';

import { getDisplayImage, getGridImageUrl, getTitle } from '../helpers';
import { makeStyles } from '@material-ui/core';

interface Props {
  variant: GridLayoutSizes;
}

const MINI_IMAGE_HEIGHT = 130;
const SMALL_IMAGE_HEIGHT = 200;
const MEDIUM_IMAGE_HEIGHT = 260;
const LARGE_IMAGE_HEIGHT = 350;

const useStyles = makeStyles(theme => ({
  image: {
    display: 'block',
    paddingBottom: theme.spacing(0.5),
  },
}));

const ImageSection: FC<Props> = ({ variant }) => {
  const classes = useStyles();
  const dimensions = useDimensions();
  const content = useContent();

  const imageOptions = {
    height: 0,
    width: dimensions.width,
    maxWidth: dimensions.width,
  };

  let height;

  switch (variant) {
    case GridLayoutSizes.Mini:
      height = MINI_IMAGE_HEIGHT;
      imageOptions.height = MINI_IMAGE_HEIGHT;
      break;
    case GridLayoutSizes.Small:
      height = SMALL_IMAGE_HEIGHT;
      imageOptions.height = SMALL_IMAGE_HEIGHT;
      break;
    case GridLayoutSizes.Medium:
      height = MEDIUM_IMAGE_HEIGHT;
      imageOptions.height = MEDIUM_IMAGE_HEIGHT;
      break;
    case GridLayoutSizes.Large:
      height = LARGE_IMAGE_HEIGHT;
      imageOptions.height = LARGE_IMAGE_HEIGHT;
      break;
  }

  const title = getTitle(content);
  const displayImage = getDisplayImage(content);
  const imageUrl = getGridImageUrl(displayImage, imageOptions);

  if (!displayImage) {
    return null;
  }

  return (
    <RouterLink className={classes.image} to={`content/${content.content_id}`}>
      <img height={height} alt={title} {...getImageSrc(imageUrl)} />
    </RouterLink>
  );
};

export default ImageSection;
